export default "__VITE_ASSET__13103a55__"